<template>
  <div class="alipay-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i> 首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-s-custom"></i> 角色列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 卡片内容 -->
    <el-card class="alipay-card" shadow="never">
      <!-- 搜索栏 -->
      <div class="search-bar">
        <el-form :inline="true" :model="searchForm" size="small">
          <el-form-item label="角色名称">
            <el-input 
              v-model="searchForm.name" 
              placeholder="请输入角色名称"
              prefix-icon="el-icon-search"
              clearable
              class="search-input"
            ></el-input>
          </el-form-item>
          <el-form-item label="状态">
            <el-select 
              v-model="searchForm.status" 
              placeholder="请选择状态"
              clearable
              class="status-select"
            >
              <el-option label="启用" :value="1"></el-option>
              <el-option label="禁用" :value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchSubmit" icon="el-icon-search">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="addData" icon="el-icon-plus">新增角色</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!-- 统计卡片 -->
      <div class="stat-cards">
        <div class="stat-card">
          <div class="stat-icon total">
            <i class="el-icon-s-custom"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ total }}</div>
            <div class="stat-label">总角色数</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon active">
            <i class="el-icon-check"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ activeCount }}</div>
            <div class="stat-label">已启用</div>
          </div>
        </div>
        <div class="stat-card">
          <div class="stat-icon inactive">
            <i class="el-icon-close"></i>
          </div>
          <div class="stat-info">
            <div class="stat-value">{{ inactiveCount }}</div>
            <div class="stat-label">已禁用</div>
          </div>
        </div>
      </div>

      <!-- 表格 -->
      <div class="table-wrapper">
        <el-table
          border
          :data="tableLoadData"
          style="width: 100%"
          row-key="id"
          :tree-props="{children: 'children'}"
          size="medium"
          :header-cell-style="headerCellStyle"
          :row-style="rowStyle"
          v-loading="loading"
          element-loading-text="加载中..."
        >
          <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
          
          <el-table-column label="角色名称" min-width="150">
            <template slot-scope="scope">
              <div class="role-name">
                <i class="el-icon-s-custom"></i>
                <span>{{ scope.row.name }}</span>
              </div>
            </template>
          </el-table-column>
          
          <el-table-column label="是否超级管理员" width="130" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.is_root == 1 ? 'danger' : 'info'" size="small" effect="plain">
                {{ scope.row.is_root == 1 ? '超级管理员' : '普通角色' }}
              </el-tag>
            </template>
          </el-table-column>
          
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-switch
                :value="scope.row.status === 1"
                disabled
                active-color="#00b578"
                inactive-color="#ff4d4f"
              ></el-switch>
            </template>
          </el-table-column>
          
          <el-table-column prop="remark" label="备注" min-width="150" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span class="remark-text">{{ scope.row.remark || '-' }}</span>
            </template>
          </el-table-column>
          
          <el-table-column label="操作" width="220" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button 
                type="text" 
                size="small" 
                class="edit-btn"
                @click="handelEdit(scope.row)"
              >
                <i class="el-icon-edit-outline"></i> 编辑
              </el-button>
              <el-button 
                v-if="scope.row.is_root != 1"
                type="text" 
                size="small" 
                class="delete-btn"
                @click="handelDel(scope.row)"
              >
                <i class="el-icon-delete"></i> 删除
              </el-button>
              <el-tooltip content="设置权限" placement="top" effect="dark">
                <el-button 
                  type="text" 
                  size="small" 
                  class="permission-btn"
                  @click="handelSelect(scope.row)"
                >
                  <i class="el-icon-folder-checked"></i> 权限
                </el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 空状态 -->
      <div v-if="tableLoadData.length === 0 && !loading" class="empty-state">
        <i class="el-icon-s-custom"></i>
        <p>暂无角色数据</p>
        <el-button type="primary" size="small" @click="addData">立即添加</el-button>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrapper" v-if="total > 0">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          :pager-count="5"
        >
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增编辑弹框 -->
    <el-dialog 
      :title="dialogTitle" 
      :visible.sync="dialogFormVisible" 
      width="520px"
      :close-on-click-modal="false"
      class="alipay-dialog"
      @closed="handleDialogClosed"
    >
      <div class="dialog-content">
        <el-form :model="form" :rules="rules" ref="form" label-width="100px" label-position="right" size="small">
          <el-form-item label="角色名称" prop="name">
            <el-input 
              v-model="form.name" 
              placeholder="请输入角色名称"
              prefix-icon="el-icon-s-custom"
              clearable
            ></el-input>
          </el-form-item>

          <el-form-item label="状态" prop="status">
            <el-select 
              v-model="form.status" 
              placeholder="请选择状态"
              class="full-width"
            >
              <el-option label="启用" :value="1">
                <span style="color: #00b578;">● 启用</span>
              </el-option>
              <el-option label="禁用" :value="0">
                <span style="color: #ff4d4f;">● 禁用</span>
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="备注" prop="remark">
            <el-input 
              v-model="form.remark" 
              type="textarea"
              :rows="3"
              placeholder="请输入备注信息"
              maxlength="200"
              show-word-limit
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancelForm">取 消</el-button>
        <el-button size="medium" type="primary" @click="submitForm">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 设置权限弹框 -->
    <el-dialog 
      title="权限设置" 
      :visible.sync="powerDialogForm" 
      width="600px"
      :close-on-click-modal="false"
      class="alipay-dialog power-dialog"
      @closed="handlePowerDialogClosed"
    >
      <div class="dialog-content">
        <div class="power-tip">
          <i class="el-icon-info"></i>
          <span>勾选需要授权的菜单权限，取消勾选将移除对应权限</span>
        </div>
        <el-form :model="powerForm" ref="powerForm">
          <el-form-item label="权限列表" label-width="100px">
            <div class="tree-wrapper">
              <el-tree
                ref="tree"
                :data="roleList"
                show-checkbox
                :props="defaultProps"
                default-expand-all
                node-key="id"
                highlight-current
                :check-strictly="true"
                @check="handleCheckChange"
                :default-checked-keys="defaultCateIds"
              >
                <span class="custom-tree-node" slot-scope="{ node, data }">
                  <i :class="data.icon || 'el-icon-menu'"></i>
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </el-form-item>
        </el-form>
      </div>
      
      <div slot="footer" class="dialog-footer">
        <el-button size="medium" @click="cancelPowerForm">取 消</el-button>
        <el-button size="medium" type="primary" @click="powerSubmitForm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import moment from 'moment'

export default {
  name: "proxyRoleList",
  data() {
    return {
      loading: false,
      
      // 搜索表单
      searchForm: {
        name: "",
        status: ""
      },
      
      // 统计数据
      activeCount: 0,
      inactiveCount: 0,
      
      // 表格数据
      tableLoadData: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      id: '',
      
      // 表单数据
      form: {
        id: '',
        name: '',
        status: 1,
        remark: '',
        proxy_id: sessionStorage.getItem('proxy_id')
      },
      
      // 验证规则
      rules: {
        name: [
          { required: true, message: '请输入角色名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      
      // 弹框控制
      dialogFormVisible: false,
      powerDialogForm: false,
      dialogTitle: '',
      
      // 权限相关
      roleList: [],
      defaultCateIds: [],
      powerForm: {
        id: ''
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      tenantUserId: []
    }
  },
  created() {
    this.DataList()
  },
  methods: {
    // 表格样式配置
    headerCellStyle() {
      return {
        background: '#f5f7fa',
        color: '#1f2d3d',
        fontWeight: '500',
        fontSize: '14px',
        borderBottom: '1px solid #e4e7ed'
      }
    },
    rowStyle() {
      return {
        cursor: 'pointer'
      }
    },
    
    // 计算统计数据
    calculateStats() {
      if (!this.tableLoadData || this.tableLoadData.length === 0) {
        this.activeCount = 0
        this.inactiveCount = 0
        return
      }
      
      this.activeCount = this.tableLoadData.filter(item => item.status === 1).length
      this.inactiveCount = this.tableLoadData.filter(item => item.status === 0).length
    },
    
    // 重置搜索
    resetSearch() {
      this.searchForm = {
        name: "",
        status: ""
      }
      this.currentPage = 1
      this.DataList()
      this.$message.success('已重置搜索条件')
    },
    
    // 获取角色列表
    DataList() {
      this.loading = true
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        page: this.currentPage,
        pageSize: this.pageSize,
        proxy_id: sessionStorage.getItem('proxy_id'),
      }
      
      if (this.searchForm.name) param.name = this.searchForm.name
      if (this.searchForm.status !== '') param.status = this.searchForm.status
      
      this.$axios.getProxyRoleList(param).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.tableLoadData = res.data || []
          this.total = res.data?.length || 0
          this.calculateStats()
        }
      }).catch(error => {
        this.loading = false
        console.log(error)
      })
    },
    
    // 设置每页条数
    handleSizeChange(newSize) {
      this.pageSize = newSize
      this.currentPage = 1
      this.DataList()
    },
    
    // 分页跳转
    handleCurrentChange(newPage) {
      this.currentPage = newPage
      this.DataList()
    },
    
    // 搜索
    searchSubmit() {
      this.currentPage = 1
      this.DataList()
    },
    
    // 新增角色
    addData() {
      this.dialogTitle = '新增角色'
      this.id = ''
      this.form = {
        id: '',
        name: '',
        status: 1,
        remark: '',
        proxy_id: sessionStorage.getItem('proxy_id')
      }
      this.dialogFormVisible = true
    },
    
    // 编辑角色
    handelEdit(row) {
      this.dialogTitle = '编辑角色'
      this.id = row.id
      this.form = {
        id: row.id,
        name: row.name,
        status: row.status,
        remark: row.remark || '',
        proxy_id: sessionStorage.getItem('proxy_id')
      }
      this.dialogFormVisible = true
    },
    
    // 删除角色
    handelDel(row) {
      this.$confirm(`确定要删除角色"${row.name}"吗？删除后无法恢复`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        const param = {
          company_id: sessionStorage.getItem('company_id'),
          access_token: sessionStorage.getItem('token'),
          id: row.id,
        }
        this.$axios.proxyRoleDel(param).then(res => {
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.DataList()
          } else {
            this.$message.error(res.msg)
          }
        }).catch(error => {
          console.log(error)
          this.$message.error('删除失败')
        })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    
    // 弹框关闭回调
    handleDialogClosed() {
      this.$refs.form?.resetFields()
    },
    
    // 取消表单
    cancelForm() {
      this.dialogFormVisible = false
    },
    
    // 提交表单
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const param = {
            name: this.form.name,
            remark: this.form.remark,
            status: this.form.status,
            proxy_id: this.form.proxy_id,
            company_id: sessionStorage.getItem('company_id'),
            access_token: sessionStorage.getItem('token')
          }
          
          if (this.id) {
            param.id = this.id
          }
          
          this.$axios.proxyRoleSave(param).then(res => {
            if (res.code == 200) {
              this.$message.success(res.msg)
              this.DataList()
              this.dialogFormVisible = false
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      })
    },
    
    // 权限设置弹框关闭回调
    handlePowerDialogClosed() {
      this.defaultCateIds = []
      this.tenantUserId = []
    },
    
    // 取消权限设置
    cancelPowerForm() {
      this.powerDialogForm = false
    },
    
    // 权限设置
    handelSelect(row) {
      this.id = row.id
      this.powerForm.id = row.id
      this.powerDialogForm = true
      
      const param = {
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        proxy_id: sessionStorage.getItem('proxy_id'),
      }
      
      this.$axios.proxyModuleFindTree(param).then(res => {
        if (res.code == 200) {
          this.roleList = this.buildTree(res.data)
          this.getUserRoleTree(row.id)
        }
      })
    },
    
    // 构建树形结构
    buildTree(data) {
      if (!data || data.length === 0) return []
      return data.map(v => ({
        id: v.id,
        name: v.name,
        icon: v.icon,
        children: v.children ? this.buildTree(v.children) : []
      }))
    },
    
    // 获取用户已有权限
    getUserRoleTree(roleId) {
      const param = {
        role_id: roleId,
        operator_id: sessionStorage.getItem('user_id'),
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        proxy_id: sessionStorage.getItem('proxy_id'),
      }
      
      this.$axios.proxyRoleModuleList(param).then((res) => {
        if (res.code == 200 && res.data) {
          this.defaultCateIds = res.data.map(item => item.id)
          this.$nextTick(() => {
            if (this.$refs.tree) {
              this.$refs.tree.setCheckedKeys(this.defaultCateIds)
              this.tenantUserId = [...this.defaultCateIds]
            }
          })
        }
      })
    },
    
    // 权限树勾选变化
    handleCheckChange() {
      if (this.$refs.tree) {
        const checkedKeys = this.$refs.tree.getCheckedKeys()
        const halfCheckedKeys = this.$refs.tree.getHalfCheckedKeys()
        this.tenantUserId = [...new Set([...checkedKeys, ...halfCheckedKeys])]
      }
    },
    
    // 提交权限设置
    powerSubmitForm() {
      const param = {
        id: this.id,
        module_ids: this.tenantUserId,
        company_id: sessionStorage.getItem('company_id'),
        access_token: sessionStorage.getItem('token'),
        proxy_id: sessionStorage.getItem('proxy_id')
      }
      
      this.$axios.proxyRoleSetPower(param).then(res => {
        if (res.code == 200) {
          this.$message.success(res.msg)
          this.powerDialogForm = false
          this.DataList()
        } else {
          this.$message.error(res.msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.alipay-container {
  padding: 16px 20px;
  background: #f5f7fa;
  min-height: calc(100vh - 60px);
}

.breadcrumb-wrapper {
  margin-bottom: 16px;
  .el-breadcrumb { font-size: 14px; i { margin-right: 4px; } }
}

.alipay-card {
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  &:hover { box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.08); }
  .el-card__body { padding: 20px 24px; }
}

// 搜索栏样式
.search-bar {
  background: #f8f9fc;
  padding: 16px 20px;
  border-radius: 12px;
  margin-bottom: 20px;
  
  .el-form-item { margin-bottom: 0; }
  .search-input { width: 200px; }
  .status-select { width: 120px; }
  
  .search-input ::v-deep .el-input__inner,
  .status-select ::v-deep .el-input__inner {
    border-radius: 20px;
  }
  
  .el-button--primary {
    background: #1677ff; border-color: #1677ff; border-radius: 20px; padding: 8px 20px;
    &:hover { background: #4096ff; border-color: #4096ff; }
  }
  .el-button--success {
    background: #00b578; border-color: #00b578; border-radius: 20px; padding: 8px 20px;
    &:hover { background: #1acd8c; border-color: #1acd8c; }
  }
}

// 统计卡片样式
.stat-cards {
  display: flex; gap: 20px; margin-bottom: 24px; flex-wrap: wrap;
  .stat-card {
    flex: 1; min-width: 130px; background: linear-gradient(135deg, #fff 0%, #f8f9fc 100%);
    border-radius: 16px; padding: 20px; display: flex; align-items: center; gap: 16px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04); transition: all 0.3s ease;
    &:hover { transform: translateY(-2px); box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); }
    .stat-icon {
      width: 48px; height: 48px; border-radius: 50%; display: flex; align-items: center; justify-content: center; font-size: 24px; color: #fff;
      &.total { background: linear-gradient(135deg, #1677ff, #4096ff); }
      &.active { background: linear-gradient(135deg, #00b578, #1acd8c); }
      &.inactive { background: linear-gradient(135deg, #e6a23c, #ebb563); }
    }
    .stat-info {
      .stat-value { font-size: 28px; font-weight: 700; color: #1f2d3d; line-height: 1.2; }
      .stat-label { font-size: 13px; color: #8c8f98; margin-top: 4px; }
    }
  }
}

// 表格样式
.table-wrapper { margin-bottom: 20px; min-height: 350px; }
.el-table { border-radius: 12px; overflow: hidden; &::before { display: none; } th { background: #fafbfc !important; font-weight: 500; } td { border-bottom: 1px solid #f0f0f0; } .el-table__row { transition: background 0.2s; &:hover { background: #f8f9fc; } } }

.role-name { display: flex; align-items: center; gap: 8px; i { font-size: 16px; color: #1677ff; } span { font-weight: 500; } }
.remark-text { color: #8c8f98; font-size: 12px; }

.edit-btn { color: #1677ff; margin-right: 8px; i { margin-right: 4px; } &:hover { color: #4096ff; } }
.delete-btn { color: #ff4d4f; margin-right: 8px; i { margin-right: 4px; } &:hover { color: #ff7875; } }
.permission-btn { color: #00b578; i { margin-right: 4px; } &:hover { color: #1acd8c; } }

.empty-state { text-align: center; padding: 60px 20px; color: #c0c4cc; i { font-size: 64px; } p { margin-top: 16px; font-size: 14px; } .el-button { margin-top: 20px; border-radius: 20px; } }
.pagination-wrapper { display: flex; justify-content: flex-end; padding-top: 16px; border-top: 1px solid #f0f0f0; .el-pagination .el-pager li.active { background: #1677ff; color: #fff; } }

// 弹框样式
.alipay-dialog .el-dialog {
  border-radius: 20px; overflow: hidden; box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);
  .el-dialog__header { background: linear-gradient(135deg, #1677ff 0%, #4096ff 100%); padding: 20px 24px; .el-dialog__title { color: #fff; font-size: 18px; font-weight: 500; } }
  .el-dialog__body { padding: 24px; }
  .el-dialog__footer { padding: 16px 24px 24px; border-top: 1px solid #f0f0f0; }
}

.power-tip { background: #e6f4ff; padding: 10px 16px; border-radius: 8px; margin-bottom: 16px; color: #1677ff; font-size: 13px; i { margin-right: 8px; } }
.tree-wrapper { max-height: 400px; overflow-y: auto; border: 1px solid #e4e7ed; border-radius: 8px; padding: 12px; ::v-deep .el-tree { .el-tree-node__content { height: 36px; &:hover { background: #f5f7fa; } } .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner { background-color: #1677ff; border-color: #1677ff; } } }
.custom-tree-node { display: flex; align-items: center; i { margin-right: 8px; color: #1677ff; font-size: 14px; } }

.dialog-footer {
  display: flex; justify-content: flex-end; gap: 12px;
  .el-button { border-radius: 20px; padding: 9px 24px; }
  .el-button--primary { background: #1677ff; border-color: #1677ff; &:hover { background: #4096ff; border-color: #4096ff; } }
}
</style>